import React from 'react'

import {handleChange} from 'Skelet/src/modules/functions.js'
import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'


export default class ModalPassword extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      password:"", password_current:"", password_validation:"", pwd_text:"",
    };

    this.validatePasswords = this.validatePasswords.bind(this);
  }

  render() {
    if(this.props.shouldShow) {
      return (
        <ModalWrapper switchState={this.props.close}>
          <form onSubmit={this.validatePasswords}>
            <div><input type="password" value={this.state.password_current} onChange={(e) => handleChange(this, "password_current", e)} placeholder={this.props.i18n_texts["core_settings_changepassword_current"][this.props.app_language]} autoFocus /></div>
            <div><input type="password" value={this.state.password} onChange={(e) => handleChange(this, "password", e)} placeholder={this.props.i18n_texts["core_settings_changepassword_new"][this.props.app_language]} /></div>
            <div><input type="password" value={this.state.password_validation} onChange={(e) => handleChange(this, "password_validation", e)} placeholder={this.props.i18n_texts["core_settings_changepassword_newrepeat"][this.props.app_language]} /></div>
            <div><input type="submit" value={this.props.i18n_texts["core_settings_changepassword_confirm"][this.props.app_language]} disabled={this.props.account_update_is_fetching} /></div>
            {this.state.pwd_text}
          </form>
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

  validatePasswords(e) {
    e.preventDefault();
    if(this.state.password === this.state.password_validation) {
      this.setState({"pwd_text":""});
      this.props.close(e);
      this.props.setPasswords(this.state.password, this.state.password_current);
    } else {
      this.setState({"pwd_text":this.props.i18n_texts["core_settings_changepassword_pwdtext"][this.props.app_language]});
    }
  }

}



// WEBPACK FOOTER //
// ./src/containers/ModalPassword.js